export default {
    carregando: false,
    items: [],
}
